<template>
    <div>
        <el-row :gutter="20" v-show="id < 0">
            <el-col :span="6">
                <Group ref="group" type="voice" @click="changeGroup" @select="moveGroup"></Group>
            </el-col>
            <el-col :span="18">
                <RemoteTable ref="table" :form="form" :table="table" @selection-change="selections = $event">
                    <template #default="{row, property}">
                        <template v-if="property === 'name'">
                            <el-link type="primary" :underline="false" @click="id = row.id">
                                {{row['name']}}
                            </el-link>
                        </template>
                    </template>
                </RemoteTable>
            </el-col>
        </el-row>
        <Template :id="id" :groupId="groupId" v-if="id > -1" @close="closeTemplate"></Template>
    </div>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'
    import Group from '../page/Group'
    import Template from './Template'

    export default {
        components: {
            RemoteTable,
            Group,
            Template,
        },
        data() {
            return {
                id: -1,
                groupId: 0,
                form: {
                    configs: [
                        {name: "name", label: "模板名称", type: "input", op: "contains", value: ""},
                        {name: "groupId", type: "hidden", value: "0"},
                        {label: "状态", name: "status", type: "select", value: "", url: "/dict/list/public/status"},
                    ],
                    tools: [
                        {
                            icon: "el-icon-plus", click: () => {
                                this.id = 0;
                            }
                        },
                        {
                            label: "迁移", click: () => {
                                this.$refs.group.showSelect();
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/voice_template",
                    checkbox: true,
                    columns: [
                        {label: "平台模板编号", name: "id", width: 120},
                        {label: "模板名称", name: "name", width: 200},
                        {label: "语言", name: "language", width: 100},
                        {label: "模板内容", name: "content"},
                        {label: "状态", name: "status", width: 100},
                        {label: "创建时间", name: "createTime", width: 150},
                    ],
                    tools: [
                        {
                            icon: "el-icon-copy-document", content: "复制", click: (row) => {
                                this.$axios.get("/voice_template/get/" + row.id).then(result => {
                                    delete result['createTime'];
                                    delete result['id'];
                                    this.$axios.post("/voice_template/save", result).then(() => {
                                        this.$refs.table.load();
                                    })
                                })
                            }
                        }
                    ]
                },
                selections: []
            }
        },
        methods: {
            changeGroup(group) {
              if (group < 0) {
                this.form.configs[1]['value'] = "";
              } else {
                this.form.configs[1]['value'] = group;
              }
                this.groupId = group;
                this.$refs.table.query();
            },
            moveGroup(group) {
                let arr = [];
                this.selections.forEach(selection => {
                    arr.push(selection['id']);
                });
                if (arr.length < 1) {
                    this.$message.warning("请选择需要迁移分组的项！");
                    return;
                }
                this.$axios.post("/group/move", {
                    group: group,
                    type: "voice",
                    ids: arr
                }).then(() => {
                    this.$refs.table.query();
                });
            },
            closeTemplate(reload) {
                this.id = -1;
                if (reload) {
                    this.$refs.table.load();
                }
            }
        }
    }
</script>